import { getGuestCountry } from '../api/geoLocation/geoLocation.api';

const GUEST_COUNTRY_KEY = 'guest_country';

let countryRequest: Promise<string | null> | null = null;

export const getStoredGuestCountry = (): string | null => {
  return sessionStorage.getItem(GUEST_COUNTRY_KEY);
};

export const initializeGuestCountry = async (): Promise<string | null> => {
  // Reuse country if already detected in this tab.
  const storedCountry = getStoredGuestCountry();

  if (storedCountry) {
    return storedCountry;
  }

  // Prevent duplicate API requests during simultaneous initialization.
  if (countryRequest) {
    return countryRequest;
  }

  countryRequest = (async () => {
    try {
      const response = await getGuestCountry();

      if (response.success && response.countryCode) {
        const countryCode = response.countryCode.toUpperCase();

        sessionStorage.setItem(GUEST_COUNTRY_KEY, countryCode);

        return countryCode;
      }

      return null;
    } catch (error) {
      console.error('Failed to detect guest country:', error);
      return null;
    } finally {
      countryRequest = null;
    }
  })();

  return countryRequest;
};